import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardCard from '../../components/DashboardCards';
import MailDetails from '../Mail/MailDetails';
import SentMails from '../Mail/SentMailList';
import ScheduledMails from '../Mail/ScheduledMailList';
import TotalUsers from '../../components/TotalUsers';


const ScheduledMailDetails = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('mailDetails'); // Track active tab (default is 'mailDetails')
  const navigate = useNavigate();
  
  // Get isAdmin from sessionStorage directly
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  
  useEffect(() => {
    const BUId = sessionStorage.getItem('BUId');
    
    if (!BUId) {
      navigate('/login');
      return;
    }

    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Login/GetDashboardDetails?BUId=${BUId}`);
        
        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await userResponse.json();
        setUserData(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Function to change the active tab when a card is clicked
  const handleCardClick = (tab) => {
    console.log(tab)
    setActiveTab(tab);
  };
console.log("userData",userData)
  return (
    <div className="space-y-6">
      {/* <div className="bg-blue-50 p-6 rounded-lg">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Welcome, {userData[0].buName}
        </h1>
        <p className="text-gray-600">Here's an overview of your dashboard</p>
      </div> */}

      <div className={`grid gap-6 ${isAdmin ? 'grid-cols-1 md:grid-cols-3' : 'grid-cols-1 md:grid-cols-3'}`}>
        {isAdmin && (
          <DashboardCard
            title="Total Users"
            value={userData?.[0]?.totalUsers ?? 0}
            icon="users"
            colorScheme="blue"
            className="w-full"
            onClick={() => handleCardClick('totalUsers')} // Optional for admin use
          />
        )}
        
        <DashboardCard
          title="Scheduled Mails"
          value={userData?.[0]?.scheduledMailCount ?? 0}
          icon="pending"
          colorScheme="green"
          className="w-full"
          onClick={() => handleCardClick('scheduledMails')}
        />
        
        <DashboardCard
          title="Sent Mails"
          value={userData?.[0]?.sentMailCount ?? 0}
          icon="mail"
          colorScheme="orange"
          className="w-full"
          onClick={() => handleCardClick('sentMails')}
        />
        
        <DashboardCard
          title="Mail Logs"
          value={userData?.[0]?.mailLogCount ?? 0}
          icon="mail"
          colorScheme="blue"
          className="w-full"
          onClick={() => handleCardClick('mailDetails')} // Optional card
        />
      </div>
 
      <div className="bg-white p-6 rounded-lg shadow-md">
        {activeTab === 'mailDetails' && <MailDetails />}
        {activeTab === 'scheduledMails' && <ScheduledMails />}
        {activeTab === 'sentMails' && <SentMails />}
        {activeTab === 'totalUsers' && <TotalUsers/>}
      </div>
    </div>
  );
};

export default ScheduledMailDetails;
